import { createContext, useContext } from 'react';
const recordIdOverrideContext = createContext(undefined);
// Lets a page force the recordId that `useRecordId()` resolves when it is not present in the route.
// The demo dashboard lives on a clean `/nova/demo-campaign-dashboard` URL with no `:recordId` segment,
// but the shared dashboard page must behave as the demo campaign. When no provider is mounted the
// context is undefined, so `useRecordId` keeps its normal router-driven behavior and existing pages are
// unaffected. This is an additive, opt-in override; the route value always wins over it.
export function RecordIdOverrideProvider({ value, children }) {
    return (<recordIdOverrideContext.Provider value={value}>
			{children}
		</recordIdOverrideContext.Provider>);
}
export function useRecordIdOverride() {
    return useContext(recordIdOverrideContext);
}
